import classNames from 'classnames'
import React, { PropsWithChildren } from 'react'
import { useTranslations } from '../../hooks/useTranslations'

export interface LabelProps {
  additionalClassName?: string
  htmlFor?: string
  required?: boolean
}

export const Label = ({
  additionalClassName,
  children,
  htmlFor,
  required,
}: PropsWithChildren<LabelProps>) => {
  const translations = useTranslations()

  const optionalText = translations.optional ? `(${translations.optional})` : undefined

  const requiredText = translations.required ? `(${translations.required})` : undefined

  return (
    <label
      className={classNames(
        'block font-t text-t-200 text-secondary-darker',
        additionalClassName
      )}
      htmlFor={htmlFor}
    >
      {children}

      <span className="ml-5 text-shade-medium-dim">
        {required ? requiredText : optionalText}
      </span>
    </label>
  )
}
